import { useIntl } from 'react-intl';

import { IconSearch } from '@xing-com/icons';

import { SearchDropdownItem } from './search-dropdown-item';

export const SearchDropdownList: React.FC = () => {
  const { formatMessage } = useIntl();

  const NAVIGATION_BADGE_NO_BADGE = 'navigation_badge_no_badge';

  return (
    <>
      <SearchDropdownItem
        itemKey="members"
        icon={IconSearch}
        href="/search/members"
        title={formatMessage({ id: 'SEARCH_DROPDOWN_MEMBERS' })}
        tracking={{
          nwt_nav: 'search_member_search',
          sc_o: 'navigation_search_member_search',
          sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
        }}
      />
      <SearchDropdownItem
        itemKey="jobs"
        icon={IconSearch}
        href="/jobs/search/ki"
        title={formatMessage({ id: 'SEARCH_DROPDOWN_JOBS' })}
        tracking={{
          nwt_nav: 'search_job_search',
          sc_o: 'navigation_search_job_search',
          sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
        }}
      />
      <SearchDropdownItem
        itemKey="companies"
        icon={IconSearch}
        href="/search/companies"
        title={formatMessage({ id: 'SEARCH_DROPDOWN_COMPANIES' })}
        tracking={{
          nwt_nav: 'search_companies_search',
          sc_o: 'navigation_search_companies_search',
          sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
        }}
      />
    </>
  );
};
